<div class="h-[400px] px-[30px]">
  <div class="font-montserrat flex flex-col flex-nowrap items-center py-[21px]">
    <div class="max-w-full text-[20px] whitespace-nowrap overflow-y-hidden overflow-x-auto scrollbar-thin scrollbar-thumb-neutral">{{ summary.questionText }}</div>
    <div class="max-w-full font-[14px] whitespace-nowrap overflow-y-hidden overflow-x-auto scrollbar-thin scrollbar-thumb-neutral">{{ summary.answers.length }} responses</div>

    <div class="w-full max-h-[280px] mt-[18px] overflow-y-auto scrollbar-thin scrollbar-thumb-neutral">
      @for (answerText of summary.answers; track answerText) {
        <div class="text-[14px] bg-base-100 rounded-[5px] w-full p-[19px] mb-[10px]">
          {{ answerText }}
        </div>
      }
    </div>
  </div>
</div>